/* eslint-disable no-return-assign */
import Promise from 'bluebird';

class Loader {
    constructor() {
        this._promises = {};
    }
    load(host = 'https://beta.web.plus.espn.com', version = 'latest') { // TODO: DTC - point to prod by default
        return (
            this._promises[version] ||
            (this._promises[version] = new Promise((resolve, reject) => {
                if (window.BamVideoExtensionVersioned && window.BamVideoExtensionVersioned[version]) {
                    resolve(window.BamVideoExtensionVersioned[version]);
                } else {
                    // TODO: take `environment` into account
                    const url = `${host}/builds/${version}/dist/index.js`;
                    const script = document.createElement('script');
                    script.async = true;

                    script.onload = () => {
                        if (window.BamVideoExtension) {
                            if (!window.BamVideoExtensionVersioned) {
                                window.BamVideoExtensionVersioned = {};
                            }
                            window.BamVideoExtensionVersioned[version] = window.BamVideoExtension;
                            // delete window.BamVideoExtension;
                            resolve(window.BamVideoExtensionVersioned[version]);
                        } else {
                            reject(new Error('script loaded but window.BamVideoExtension not found.'));
                        }
                    };

                    script.onerror = () => {
                        reject(new Error('failed to load BAM SDK'));
                    };

                    script.src = url;
                    document.head.appendChild(script);
                }
            }))
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./app/webapp/common/video-player/player-tech/BAMPlayer/Loader.js